import { render, staticRenderFns } from "./InfoPanel.vue?vue&type=template&id=2a9a3667&scoped=true"
import script from "./InfoPanel.vue?vue&type=script&lang=ts"
export * from "./InfoPanel.vue?vue&type=script&lang=ts"
import style0 from "./InfoPanel.vue?vue&type=style&index=0&id=2a9a3667&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9a3667",
  null
  
)

export default component.exports